import { type FunctionComponent, type ReactNode } from 'react';
import clsx from 'clsx';
import { type Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {ADMIN_PAGE_Y_OFFSET, ADMIN_PAGE_Y_PADDING} from 'constants/offsets';

type StyleProps = {
  colorBlockPercent?: number;
}

const useStyles = makeStyles((theme : Theme) => ({
  container: {
    background: ({colorBlockPercent = 0} : StyleProps) => `linear-gradient(
      180deg,
      ${theme.palette.primary.main} ${colorBlockPercent}%,
      ${theme.palette.background.default} ${colorBlockPercent}%
    )`,
    padding: `${ADMIN_PAGE_Y_PADDING}px 30px`,
    [theme.breakpoints.up('md')]: {
      minHeight: `calc(100vh - ${ADMIN_PAGE_Y_OFFSET}px)`,
    },
    [theme.breakpoints.down('md')]: {
      minHeight: 'calc(100vh)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: `${ADMIN_PAGE_Y_PADDING * 3}px 30px`,
    },
  },
}), {name: 'AdminPageContainer'});

export type AdminPageContainerProps = StyleProps & {
  children: ReactNode;
  className?: string;
};

const AdminPageContainer: FunctionComponent<AdminPageContainerProps> = ({ className, children, colorBlockPercent = 0 }): JSX.Element => {
  const classes = useStyles({colorBlockPercent});

  return (
    <div className={clsx([classes.container, className])}>
      {children}
    </div>
  );
};

export default AdminPageContainer;